import { useEffect } from 'react';

export const PAGE_JSON_LD_ID = 'ab-page-jsonld';

export function usePageJsonLd(jsonLd) {
  const jsonText = jsonLd ? JSON.stringify(jsonLd) : '';

  useEffect(() => {
    if (!jsonText) return undefined;

    let script = document.getElementById(PAGE_JSON_LD_ID);
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = PAGE_JSON_LD_ID;
      document.head.appendChild(script);
    }
    script.textContent = jsonText;

    return () => {
      document.getElementById(PAGE_JSON_LD_ID)?.remove();
    };
  }, [jsonText]);
}
